import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: null,
    userData: null,
    role: null,
    modules: [],
    authPermission: [],
    user: {},
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
    saveRole: (state, action) => {
      state.role = action.payload;
    },
    saveModule: (state, action) => {
      state.modules = action.payload;
    },
    saveUser: (state, action) => {
      state.user = action.payload;
    },
    saveAuthPermission: (state, action) => {
      state.authPermission = action.payload;
    },
    resetData: (state, action) => {
      state.userData = null;
      state.authData = null;
    },
    setAccessToken: (state, action) => {
      state.authData = state.authData && {
        ...state.authData,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    },
  },
});

export const {
  saveAuthData,
  saveUserData,
  resetData,
  setAccessToken,
  saveRole,
  saveModule,
  saveAuthPermission,
  saveUser,
} = loginSlice.actions;

export default loginSlice.reducer;
